export const SHADOW_SHEET_GRID_DONE_MESSAGE = "mind-survival-shadow-sheet-grid-done";
export const SHADOW_SHEET_GRID_CREATED_MESSAGE = "mind-survival-shadow-sheet-grid-created";

export const SHADOW_SHEET_GRID_RESULT_STORAGE_KEY =
  "mind-survival/shadow-sheet-grid-result/v1";

export const SHADOW_SHEET_GRID_CREATE_SESSION_KEY =
  "mind-survival/shadow-sheet-grid-create-session/v1";

export type ShadowSheetGridCreateSession = {
  draftName: string;
  startedAt: number;
};

export type ShadowSheetGridResult = {
  dataUrl: string;
  createdAt: number;
};

export function saveShadowSheetGridResult(dataUrl: string): void {
  const payload: ShadowSheetGridResult = {
    dataUrl,
    createdAt: Date.now(),
  };
  sessionStorage.setItem(SHADOW_SHEET_GRID_RESULT_STORAGE_KEY, JSON.stringify(payload));
}

export function takeShadowSheetGridResult(): ShadowSheetGridResult | null {
  const raw = sessionStorage.getItem(SHADOW_SHEET_GRID_RESULT_STORAGE_KEY);
  if (!raw) return null;
  sessionStorage.removeItem(SHADOW_SHEET_GRID_RESULT_STORAGE_KEY);
  try {
    const parsed = JSON.parse(raw) as Partial<ShadowSheetGridResult>;
    if (typeof parsed.dataUrl !== "string" || !parsed.dataUrl.startsWith("data:")) {
      return null;
    }
    return {
      dataUrl: parsed.dataUrl,
      createdAt: typeof parsed.createdAt === "number" ? parsed.createdAt : Date.now(),
    };
  } catch {
    return null;
  }
}

export function notifyShadowSheetGridOpener(): void {
  try {
    window.opener?.postMessage(
      { type: SHADOW_SHEET_GRID_DONE_MESSAGE },
      window.location.origin,
    );
  } catch {
    /* cross-origin or closed */
  }
}

export function saveShadowSheetGridCreateSession(draftName: string): void {
  const payload: ShadowSheetGridCreateSession = {
    draftName: draftName.trim().slice(0, 48),
    startedAt: Date.now(),
  };
  sessionStorage.setItem(SHADOW_SHEET_GRID_CREATE_SESSION_KEY, JSON.stringify(payload));
}

export function readShadowSheetGridCreateSession(): ShadowSheetGridCreateSession | null {
  const raw = sessionStorage.getItem(SHADOW_SHEET_GRID_CREATE_SESSION_KEY);
  if (!raw) return null;
  try {
    const parsed = JSON.parse(raw) as Partial<ShadowSheetGridCreateSession>;
    if (typeof parsed.startedAt !== "number") return null;
    return {
      draftName: typeof parsed.draftName === "string" ? parsed.draftName : "",
      startedAt: parsed.startedAt,
    };
  } catch {
    return null;
  }
}

export function clearShadowSheetGridCreateSession(): void {
  sessionStorage.removeItem(SHADOW_SHEET_GRID_CREATE_SESSION_KEY);
}

export function notifyShadowSheetGridCreated(shadowName: string): void {
  try {
    window.opener?.postMessage(
      { type: SHADOW_SHEET_GRID_CREATED_MESSAGE, name: shadowName },
      window.location.origin,
    );
  } catch {
    /* cross-origin or closed */
  }
}
